import { MdCalendarMonth } from "react-icons/md";
import { BsPencilFill } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { helpers } from '../services/helpers';
import React, { useState, forwardRef, useImperativeHandle } from "react";

// TODO: FIX HEADER VERTICAL ALIGNMENT
const PainDiaryHeader = forwardRef(({
    diary,
    surgeries,
    updateCharts,
    setIsEditing,
    canEdit
}, ref) => {
    const [timeFilter, setTimeFilter] = useState('all');
    const [showFilterDropdown, setShowFilterDropdown] = useState(false);
    const navigate = useNavigate();
    const newEntry = () => navigate('/diary/entry');

    const handleTimeFilterChange = (filterKey) => {
        setTimeFilter(filterKey);
        setShowFilterDropdown(false);

        if (diary?.id && surgeries) {
            const filteredDiary = filterDataByTime(diary, filterKey, true);
            const filteredSurgeries = filterDataByTime(surgeries, filterKey, false);
            updateCharts(filteredDiary, filteredSurgeries);
        }
    };

    useImperativeHandle(ref, () => ({
        handleTimeFilterChange
    }));

    const getFilterLabel = (filterKey) => {
        const option = helpers.timeFilterOptions.find(opt => opt.key === filterKey);
        return option ? option.label : 'All Time';
    };

    const filterDataByTime = (data, filterKey, isDiaryData) => {
        if (filterKey === 'all' || !data) return data;

        const now = new Date();
        const filterOption = helpers.timeFilterOptions.find(opt => opt.key === filterKey);
        const cutoffDate = new Date(now.getTime() - (filterOption.days * 24 * 60 * 60 * 1000));

        if (isDiaryData) {
            return {
                ...data,
                entries: data.entries.filter(entry => new Date(entry.createdAt) >= cutoffDate)
            };
        } else if (Array.isArray(data)) {
            return data.filter(surgery => new Date(surgery.surgeryDate) >= cutoffDate);
        }

        return data;
    };
    const getAvailableFilters = () => {
        if (!diary?.entries?.length && !surgeries?.length) return ['all'];

        const now = new Date();
        const available = [];

        helpers.timeFilterOptions.forEach(option => {
            if (option.key === 'all') {
                available.push(option.key);
                return;
            }

            const cutoffDate = new Date(now.getTime() - (option.days * 24 * 60 * 60 * 1000));
            const hasData = (diary?.entries?.some(entry => new Date(entry.createdAt) >= cutoffDate)) ||
                (surgeries?.some(surgery => new Date(surgery.surgeryDate) >= cutoffDate));

            if (hasData) available.push(option.key);
        });

        return available.length > 1 ? available : ['all'];
    };
    return (
        <div
            style={{
                width: "100%",
                background: "white",
                position: "fixed",
                zIndex: 99,
                borderBottom: "2px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: "0.5rem"
            }}
        >
            <div
                style={{
                    display: 'flex',
                    gap: '10px',
                    marginBottom: '0.5rem',
                    marginTop: '0.5rem',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    marginRight: '0.5rem',
                    justifyContent: "flex-end"
                }}
            >
                {canEdit && (
                    <button
                        className="create-review-button"
                        onClick={newEntry}
                        style={{ height: "28px" }}
                    >
                        + New Entry
                    </button>
                )}

                {canEdit && (
                    <button
                        className="create-review-button"
                        onClick={() => setIsEditing(true)}
                        style={{ height: "28px" }}
                    >
                        <BsPencilFill />&nbsp;Edit Diary
                    </button>
                )}

                {getAvailableFilters().length > 1 && (
                    <div style={{ position: 'relative' }}>
                        <button
                            className="create-review-button"
                            onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                height: "28px"
                            }}
                        >
                            <MdCalendarMonth /> {getFilterLabel(timeFilter)}
                            <span style={{ fontSize: '12px' }}>▼</span>
                        </button>

                        {showFilterDropdown && (
                            <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                zIndex: 1000,
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                minWidth: '150px',
                                marginTop: '2px'
                            }}>
                                {getAvailableFilters().map(filterKey => (
                                    <button
                                        key={filterKey}
                                        onClick={() => handleTimeFilterChange(filterKey)}
                                        style={{
                                            width: '100%',
                                            padding: '8px 12px',
                                            border: 'none',
                                            background: filterKey === timeFilter ? '#e3f2fd' : 'white',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            color: filterKey === timeFilter ? '#1976d2' : '#333'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (filterKey !== timeFilter) {
                                                e.target.style.background = '#f5f5f5';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (filterKey !== timeFilter) {
                                                e.target.style.background = 'white';
                                            }
                                        }}
                                    >
                                        {getFilterLabel(filterKey)}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>

            {showFilterDropdown && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 999
                    }}
                    onClick={() => setShowFilterDropdown(false)}
                />
            )}
        </div>
    );
});

export default PainDiaryHeader;